export default __webpack_public_path__ + "static/jb-hifi-yellow-6c1c9da4e649a0f9ccf9efeda4ff4f3f.png";